export default "__VITE_ASSET__DmjVSV50__"